import { SHOW_ADD_TO_HOME_SCREEN, HIDE_ADD_TO_HOME_SCREEN } from "../actions";

export default function addToHomeScreen(state = false, action) {
  switch (action.type) {
    case SHOW_ADD_TO_HOME_SCREEN:
      return true;
    case HIDE_ADD_TO_HOME_SCREEN:
      return false;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/addToHomeScreen.js